import FizConfig from "./FizConfig.js";
import {code as DEVICE} from "./lib/os.js";
import $ from "./$.js";

window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}

gtag('js', new Date());

if(FizConfig.GOOGLE_ANALYTICS_GTM){
  gtag({'gtm.start':new Date().getTime(),event:'gtm.js'});
  let script = document.createElement('script')
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtm.js?id="+FizConfig.GOOGLE_ANALYTICS_GTM;
  document.head.insertAdjacentElement("afterbegin",script);
}

$(document).on("click","[data-ga-event]",function(){
  event($(this).attr('data-ga-event'));
});

export function page(pageName,title){
  gtag('set', 'page_path', pageName);
  gtag('set', 'page_location', window.location);
  if(title){
    gtag('set', 'page_title', title);
  }
  gtag('event', 'page_view');
}

export function pageNew(page_path,page_title){
  gtag({
    event:'page_view',
    page_path,
    page_title,
    page_location:window.location
  });
}
//send event which should look like this Category|Action|Label
export function event(event){
  if(typeof event === 'string'){
    event = {event:event.replace("$DEVICE",DEVICE)}
  }
  window.dataLayer.push(event);
}

export function invitationevent(eventAsString){
  event(eventAsString);
}
